import { render, staticRenderFns } from "./OtherProductName.vue?vue&type=template&id=dba53ab8&scoped=true&"
import script from "./OtherProductName.vue?vue&type=script&lang=js&"
export * from "./OtherProductName.vue?vue&type=script&lang=js&"
import style0 from "./OtherProductName.vue?vue&type=style&index=0&id=dba53ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba53ab8",
  null
  
)

export default component.exports